import axios from 'axios'
const baseUrl = '/api/'

/**
 *
 * @param {string} url
 * @param {object} options
 */
async function request(url, options) {
  let needLogin = true
  const otherHandler = options.otherHandler || {}
  if (typeof otherHandler === 'object' && otherHandler.ignoreAuth) {
    needLogin = false
  }
  const p = new Promise((resolve, reject) => {
    const method = options.method || 'GET'
    let param = {
      data: options.data,
    }
    if (method.toLowerCase() === 'get') {
      param = {
        params: options.data,
      }
    }
    const token = sessionStorage.getItem('X3-Authentication')
    const headerParam = {}
    if (token) {
      headerParam['X3-Authentication'] = token
    }
    const i18n = navigator.language || navigator.userLanguage
    Object.assign(headerParam, {
      'Accept-Language': i18n.replace('_', '-'),
    })
    axios({
      baseURL: baseUrl,
      url: `${url}`,
      method,
      ...param,
      headers: headerParam,
    })
      .then((res) => {
        if (res.data.code === 200) {
          resolve(res.data)
        } else {
          reject(res)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
  return await p.catch((err) => {
    console.log(err.data)
    if (typeof otherHandler === 'function') {
      otherHandler(err.data, err)
    } else if (
      typeof otherHandler === 'object' &&
      typeof otherHandler.otherHandler === 'function'
    ) {
      otherHandler.otherHandler(err.data, err)
    } else {
      if (err?.data?.code === 401) {
        sessionStorage.removeItem('X3-Authentication')
        location.replace(`${location.origin}`)
      } else {
        window.$message.error(err?.data?.msg || '未知错误')
      }
    }
  })
}
async function exportData(url, data, options = {}) {
  const token = sessionStorage.getItem('X3-Authentication')
  const headerParam = {}
  if (token) {
    headerParam['X3-Authentication'] = token
  }
  let res
  try {
    res = await axios({
      baseURL: baseUrl,
      method: 'post',
      url,
      data,
      responseType: 'blob',
      headers: headerParam,
    })
  } catch (error) {
    const errorBlob = error.response?.data
    if (errorBlob instanceof Blob) {
      try {
        const result = JSON.parse(await errorBlob.text())
        throw new Error(result.msg || '下载失败')
      } catch (parseError) {
        if (parseError instanceof SyntaxError) throw error
        throw parseError
      }
    }
    throw error
  }
  const contentType = res.headers['content-type'] || ''
  if (contentType.includes('json')) {
    const result = JSON.parse(await res.data.text())
    throw new Error(result.msg || '下载失败')
  }
  const disposition = res.headers['content-disposition'] || ''
  const encodedName = res.headers.filename || disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
  let fileName = options.fileName || 'download'
  if (encodedName) {
    try {
      fileName = decodeURIComponent(encodedName)
    } catch (e) {
      fileName = encodedName
    }
  }
  const link = document.createElement('a')
  const blob = new Blob([res.data], { type: options.contentType || contentType || 'application/octet-stream' })
  const objectUrl = URL.createObjectURL(blob)
  link.style.display = 'none'
  link.href = objectUrl
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(objectUrl)
}
export default {
  //封装get方法
  async get(url, data, otherHandler) {
    return await request(url, {
      method: 'GET',
      data,
      otherHandler,
    })
  },
  //封装post方法
  async post(url, data, otherHandler) {
    return await request(url, {
      method: 'POST',
      data,
      otherHandler,
    })
  },
  async put(url, data, otherHandler) {
    return await request(url, {
      method: 'PUT',
      data,
      otherHandler,
    })
  },
  async delete(url, data, otherHandler) {
    let queryStr = ''
    Object.keys(data).forEach((key) => {
      queryStr += `${key}=${data[key]}&`
    })
    queryStr = queryStr.slice(0, -1)
    return await request(`${url}?${queryStr}`, {
      method: 'DELETE',
      otherHandler,
    })
  },
  exportData,
}
